import { compose } from 'redux';
import { withProps } from 'recompose';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import { getReasonPhrase } from 'http-status-codes';

import ErrorScreen from '@dpdgroupuk/fmx-ui/components/ErrorScreen';
import { withPageControl } from '@dpdgroupuk/fmx-ui/components/Page';
import NotFound from '@dpdgroupuk/fmx-ui/components/Icons/NotFound';
import { IMAGES } from '@dpdgroupuk/fmx-ui/themes';
import { getBackgroundImage } from '../../utils/images';
import { ERROR_SCREEN, trackable } from '../../constants/analytics';
import { ERROR, HOME } from '../../constants/message';
import { goToReferenceEntry } from '../historyActions';
import { getStatusMessage } from '../../utils/errorHandling';

export default compose(
  withRouter,
  withProps(({ location }) => {
    const { status } = queryString.parse(location.search);
    return {
      status,
    };
  }),
  withPageControl({
    title: ({ status }) => {
      try {
        return getReasonPhrase(status);
      } catch (e) {
        return ERROR;
      }
    },
    backgroundImage: getBackgroundImage({
      desktopImage: IMAGES.DRIVER_BG,
      mobileImage: IMAGES.DRIVER_BG_MOBILE,
    }),
    trackable: trackable(ERROR_SCREEN),
  }),
  withProps(props => ({
    title: getStatusMessage(props.status),
    buttonText: HOME,
    onClick: () => goToReferenceEntry(props.history),
    icon: NotFound,
  }))
)(ErrorScreen);
